import { AssetChartWidget, TicketChartWidget, UserChartWidget } from "../chart-widget";
import { AssetTableWidget, TicketTableWidget, UserTableWidget } from "../table-widget";
import {
  WidgetContainerProps,
  WidgetType,
} from "../../../utils/asset-dashboard/types";
import { UserPermissionGate } from "@components/user-permission-gate";

export const WidgetContent = ({ widget }: { widget: WidgetContainerProps }) => {
  switch (widget.type) {
    case WidgetType.ASSET_TABLE:
      return (
        <UserPermissionGate caps="read_asset">
          <AssetTableWidget id={widget.id} />
        </UserPermissionGate>
      );
    case WidgetType.ASSET_CHART:
      return (
        <UserPermissionGate caps="read_asset">
          <AssetChartWidget id={widget.id} />
        </UserPermissionGate>
      );
    case WidgetType.TICKET_TABLE:
      return (
        <UserPermissionGate caps="read_ticket">
          <TicketTableWidget id={widget.id} />
        </UserPermissionGate>
      );
    case WidgetType.USER_TABLE:
      return (
        <UserPermissionGate caps="list_users">
          <UserTableWidget id={widget.id} />
        </UserPermissionGate>
      );
    case WidgetType.USER_CHART:
      return (
        <UserPermissionGate caps="list_users">
          <UserChartWidget id={widget.id} />
        </UserPermissionGate>
      );
    case WidgetType.TICKET_CHART:
      return (
        <UserPermissionGate caps="read_ticket">
          <TicketChartWidget id={widget.id} />
        </UserPermissionGate>
      );
    default:
      return null;
  }
};

export default WidgetContent;
